import { render, staticRenderFns } from "./VisualizarPerfilDialog.vue?vue&type=template&id=41722406&scoped=true"
import script from "./VisualizarPerfilDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarPerfilDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarPerfilDialog.vue?vue&type=style&index=0&id=41722406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41722406",
  null
  
)

export default component.exports